export default __webpack_public_path__ + "static/media/Espre.d6e7df16.png";